import { Outlet } from "react-router-dom";

export default function AuthRoutes() {
  return <Outlet />;
}
